<template>
  <div>
    <a-row :gutter="20">
      <a-col :span="16" class="left-panel">
        <div class="title info-row">
          数据范围选择
        </div>
        <div>
          <div class="group-title info-row">
            选择患者
          </div>
          <a-radio-group v-model="patientType" style="width: 100%" class="info-row">
            <a-row >
              <a-col :span="6">
                <a-radio value="1">
                  全部患者
                </a-radio>
              </a-col>
              <a-col :span="6">
                <a-radio value="2">
                  指定患者
                </a-radio>
              </a-col>
            </a-row>
          </a-radio-group>
        </div>
        <div style="margin-top: 10px" v-if="patientType=='2'">
          <div style="padding: 10px">
            <template v-for="(item,index) in patientNameList">
              <a-tag  :key="patientIdList[index]" closable color="blue" @close="patientNameClose(index)" style="margin-right: 10px;margin-bottom: 2px">
                <!--<label @click="patientNameClose(index)">-->
                {{item}}
                <!--</label>-->
              </a-tag>
            </template>
          </div>
          <patient-list list-url="/patient/patient/list2" :mini="true"  @onselect="handleSelect" @onmove="moveSelect"></patient-list>
        </div>
        <template v-else>
          <div>
            <div class="group-title info-row">
              选择分中心
            </div>
            <div class="group-title info-row">
              <a-checkbox v-if="!data.id" :indeterminate="center.indeterminate" :checked="center.checkAll" @change="centerCheckChange($event,center)">
                全选
              </a-checkbox>
            </div>
            <a-checkbox-group v-model="center.checkedList" @change="onCenterCheckGroupChange($event,center)" style="width: 100%" class="info-row">
              <a-row >
                <a-col :span="6" v-for="(item,index) in center.dataList" :key="index">
                  <a-checkbox :value="item.value">
                    {{item.text}}
                  </a-checkbox>
                </a-col>
              </a-row>
            </a-checkbox-group>
          </div>
          <div>
            <div class="group-title info-row">
              日期筛选
            </div>
            <div class="group-title info-row">
              注册日期：
              <a-date-picker value-format='YYYY-MM-DD' v-model="startCreateTime" />
              ~
              <a-date-picker value-format='YYYY-MM-DD' v-model="endCreateTime" />
            </div>
            <div class="group-title info-row">
              通过筛选日期：
              <a-date-picker value-format='YYYY-MM-DD' v-model="startPassDate" />
              ~
              <a-date-picker value-format='YYYY-MM-DD' v-model="endPassDate" />
            </div>
            <div class="group-title info-row">
              受试者编号：
              <a-input-number v-model="startPatientNum" placeholder="请输入"  :precision="0" style="width: 200px"/>
              ~
              <a-input-number v-model="endPatientNum" placeholder="请输入"  :precision="0" style="width: 200px"/>
            </div>
          </div>
        </template>
      </a-col>
      <a-col :span="8" class="right-panel">
        <div class="title info-row">
          导出结构配置
        </div>
        <div class=" group-title info-row">
          导出格式：excel
        </div>
        <div class="export-btn" >
          <a-button type="primary" @click="createExportHandle" :loading="loading" v-if="!data.id">导出</a-button>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import manyCheck from '@/utils/components/manyCheck'
  import { getAction,postAction } from '@/api/manage'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import Vue from 'vue'
  import PatientList from '@/views/project/patient/components/register/PatientList'
  export default {
    name: 'Type6',
    components: { PatientList },
    props:{
      data:{
        type:Object,
        default(){
          return {}
        }
      }
    },
    data(){
      return {
        loading:false,
        projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
        center:{
          indeterminate:false,
          checkedList:[],
          checkAll:true,
          dataList:[
            // {text:'四川大学华西医院',value:'HX'},
          ]
        },
        /////
        patientIdList:[],
        patientNameList:[],
        patientType:'1',
        startPassDate:'',
        endPassDate:'',
        startCreateTime:'',
        endCreateTime:'',
        startPatientNum:'',
        endPatientNum:'',
      }
    },
    methods:{
      loadDataView(){
        //回显
        if(this.data.id){
          {
            // centerIds
            if(this.data.centerIds){
              this.center.checkedList =this.data.centerIds.split(',')
            }
          }

          {
            if(this.data.patientType){
              this.patientType = this.data.patientType
            }
          }
          {
            if(this.data.patientIds){
              this.patientIdList = this.data.patientIds.split(',')
            }
            if(this.data.patientNames){
              this.patientNameList = this.data.patientNames.split(',')
            }
          }
          {
            this.startCreateTime = this.data.startCreateTime || ''
            this.endCreateTime = this.data.endCreateTime || ''
            this.startPassDate = this.data.startPassDate || ''
            this.endPassDate = this.data.endPassDate || ''
            this.startPatientNum = this.data.startPatientNum || null
            this.endPatientNum = this.data.endPatientNum || null
          }
        }
      },
      loadData(){
        this.loadDataView()
        // 中心
        getAction('/project/center/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            const checkedList = []
            const dataList = []
            res.result.forEach(center=>{
              checkedList.push(center.centerId);
              const centerInfo = {
                text:center.center.name,
                value:center.centerId,
              }
              dataList.push(centerInfo)
            })
            this.$set(this.center,'dataList',dataList)
            if(!this.data.id){
              this.$set(this.center,'checkedList',checkedList)
            }
          }
        })
      },
      centerCheckChange(e,groupInfo){
        manyCheck.centerCheckChange(e,groupInfo)
      },
      onCenterCheckGroupChange(e,groupInfo,parent){
        manyCheck.onCenterCheckGroupChange(e,groupInfo,parent)
      },
      createExportHandle(){
        if(this.patientType==='2' && this.patientIdList.length==0){
          return this.$message.warning('请选择患者');
        }
        const centerIds = this.center.checkedList.join(',')
        if(!centerIds){
          return this.$message.warning('请选择中心');
        }
        const params = {
          startCreateTime:this.startCreateTime,
          endCreateTime:this.endCreateTime,
          startPassDate:this.startPassDate,
          endPassDate:this.endPassDate,
          startPatientNum:this.startPatientNum,
          endPatientNum:this.endPatientNum,
          patientType:this.patientType,
          centerIds:centerIds,
          formatType:'1',
          projectId:this.projectId,
          type:'6'
        }
        this.loading = true
        postAction('/export/projectExport/create',params).then(res=>{
          if(res.success){
            this.$emit("back")
            this.$message.success(res.message)
          }else{
            this.$message.success(res.message)
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      handleSelect(record){
        if(this.patientIdList.indexOf(record.id)>=0){
          return
        }
        this.patientIdList.push(record.id)
        this.patientNameList.push(record.name)
      },
      moveSelect(record){
        let index = this.patientIdList.indexOf(record.id);        
        if(index < 0){
          return
        }
        this.patientIdList.splice(index, 1)
        this.patientNameList.splice(index, 1)
      },
      patientNameClose(i){
        this.patientIdList.splice(i,1);
        this.patientNameList.splice(i,1);
      },
    }
  }
</script>

<style scoped>

</style>